import script from "./MainGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./MainGrid.vue?vue&type=script&setup=true&lang=js"

import "./MainGrid.vue?vue&type=style&index=0&id=5bdc502b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdc502b"]])

export default __exports__